const credentialReducer = (state = {}, action) => {
    switch (action.type) {
        default:
            return state
    }
};

export default credentialReducer;